module.exports = __webpack_public_path__ + "static/img/up-t.7479ef00.webp";